export class ProblemSolvingListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            code: lang.problem_solving[1],
            type: lang.problem_solving[2],
            input: lang.problem_solving[3],
            search: lang.general[33],
            itemno: lang.problem_solving[97],
            jobno: lang.problem_solving[98],
            other: lang.problem_solving[99],
            descriptionoftheproblem: lang.problem_solving[4],
            openingDate: lang.problem_solving[5],
            status: lang.problem_solving[6],
            closingDate: lang.problem_solving[7],
            cost: lang.problem_solving[8],
            action: lang.problem_solving[9],
            class: lang.problem_solving[128],
            closingTime: lang.problem_solving[129],
            view: lang.problem_solving[25],
            edit: lang.problem_solving[71],
            delete: lang.problem_solving[73],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            problem_solving: lang.general[50],
            closed: lang.problem_solving[68],
            open: lang.problem_solving[67],
            checkEffectiveness: lang.problem_solving[22],
            correctiveActions: lang.problem_solving[19],
            causeanalysis: lang.problem_solving[17],
            treatment: lang.problem_solving[14],
            internalnoncon: lang.problem_solving[107],
            externalnoncon: lang.problem_solving[108],
            claim: lang.problem_solving[109],
            accident: lang.problem_solving[110],
            nearMiss: lang.problem_solving[111],
            create: lang.problem_solving[74],
            todownloadcsv: lang.problem_solving[114],
            importProblems: lang.problem_solving[70],
            clickHere: lang.problem_solving[72],
            createNewProblem: lang.problem_solving[105],
            responsible: lang.problem_solving[11],
            description: lang.problem_solving[4],
            attachments: lang.problem_solving[10],
            startingDate: lang.problem_solving[44],
            tobeclosedby: lang.problem_solving[100],
            save: lang.problem_solving[31],
            requiredField: lang.problem_solving[47],
            internalnonConformity: lang.problem_solving[107],
            suppliernonConformity: lang.problem_solving[108],
            pleaseSelect: lang.problem_solving[106],
            product: lang.problem_solving[131],
            process: lang.problem_solving[132],
            assistance: lang.problem_solving[133],
            serviceDelivery: lang.problem_solving[134],
            calibrationService : lang.problem_solving[135],
            marketing : lang.problem_solving[136],
            purchases : lang.problem_solving[137],
            maintenance : lang.problem_solving[138],
            instruments : lang.problem_solving[139],
            humanResources : lang.problem_solving[140],
            shipping : lang.problem_solving[141],
            humanError : lang.problem_solving[142],
            exportCSV: lang.general[13],
            exportPDF: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            problemDetails: lang.general[43],
            report: lang.problem_solving[115],
            treatmentImplemented: lang.problem_solving[15],
            figuresInvolved: lang.problem_solving[16],
            internalReference: lang.problem_solving[101],
            externalReference: lang.problem_solving[102],
            unlock: lang.problem_solving[32],
            date: lang.problem_solving[75],
            selectEmployee: lang.problem_solving[82],
            correctionAction: lang.problem_solving[20],
            finalAnalysis: lang.problem_solving[33],
            phase: lang.problem_solving[116],
            email: lang.problem_solving[117],
            phone: lang.problem_solving[118],
            generatePdf: lang.problem_solving[119],
            sendStakeholders: lang.problem_solving[120],
            dateofsent: lang.problem_solving[121],
            sender: lang.problem_solving[122],
            recipients: lang.problem_solving[123],
            subject: lang.problem_solving[124],
            distributionStaus: lang.problem_solving[125],
            text: lang.problem_solving[126],
            mail: lang.problem_solving[127],
            select_year: lang.general[96],
            please_select: lang.general[98],
            select_status: lang.general[97],


        }

    }

    lang() {
        return this.variables;
    }

}
